import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { translate } from 'i18n/jhipster-language';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import PRow from 'shared/ui/prow';
import { APP_LOCAL_DATETIME_FORMAT, ROWS_PER_PAGE } from 'app/config/constants';
import moment from 'moment';
import { getEntitiesByOldCardId, } from 'shared/lib/reducers/card-replacement-request.reducer';
import { isTableSkeletonRow, TABLE_SKELETON_ROW_COUNT, tableActionButtonsSkeleton, tableCellSkeleton, } from 'shared/ui/table-skeleton';
const buildSkeletonRows = () => Array.from({ length: TABLE_SKELETON_ROW_COUNT }, (_, i) => ({ id: -(i + 1) }));
const formatDt = (v) => (v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '');
const statusSeverity = (s) => {
    if (!s)
        return null;
    if (s === 'APPROVED' || s === 'COMPLETED')
        return 'success';
    if (s === 'REJECTED' || s === 'CANCELLED')
        return 'danger';
    return 'warning';
};
const mapState = ({ cardReplacementRequest }) => ({
    entities: cardReplacementRequest.entities,
    totalItems: cardReplacementRequest.totalItems,
    loading: cardReplacementRequest.loading,
    updateSuccess: cardReplacementRequest.updateSuccess,
});
const mapDispatch = {
    loadByCard: getEntitiesByOldCardId,
};
const CardReplacementRequestTabPresenter = ({ cardId, entities, totalItems, loading, updateSuccess, loadByCard, }) => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    useEffect(() => {
        setPage(0);
        setFirst(0);
    }, [cardId]);
    const load = useCallback(() => {
        if (!cardId)
            return;
        loadByCard(cardId, { page, size: ROWS_PER_PAGE });
    }, [cardId, loadByCard, page]);
    useEffect(() => {
        load();
    }, [load]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        load();
    }, [updateSuccess, load]);
    const tableValue = loading ? buildSkeletonRows() : entities.slice();
    const actionBody = (row) => isTableSkeletonRow(row) ? (tableActionButtonsSkeleton({ buttonCount: 1 })) : (_jsx(PRow, { children: _jsx(Button, { type: "button", icon: "pi pi-eye", className: "p-button-primary", onClick: () => row.id != null && navigate(`./replacement/${row.id}`, { relative: 'path' }), "aria-label": translate('entity.action.view') }) }));
    return (_jsxs(DataTable, { dataKey: "id", lazy: true, value: tableValue, first: first, paginator: !loading && totalItems > ROWS_PER_PAGE, rows: ROWS_PER_PAGE, totalRecords: totalItems, onPage: (e) => {
            setFirst(e.first ?? 0);
            setPage(e.page ?? 0);
        }, selectionMode: "single", isDataSelectable: e => !isTableSkeletonRow(e.data), resizableColumns: true, className: "mt-3", emptyMessage: translate('general.dtEmptymessage'), children: [_jsx(Column, { header: translate('form.reasonLabel'), body: row => isTableSkeletonRow(row)
                    ? tableCellSkeleton()
                    : row.reason ?? '' }), _jsx(Column, { header: translate('form.sourceChannel'), body: row => isTableSkeletonRow(row)
                    ? tableCellSkeleton()
                    : row.sourceChannel ?? '' }), _jsx(Column, { header: translate('form.status'), body: row => {
                    if (isTableSkeletonRow(row))
                        return tableCellSkeleton();
                    const s = row.status ?? '';
                    return _jsx(Tag, { value: s, severity: statusSeverity(s) ?? undefined });
                } }), _jsx(Column, { header: translate('form.requestedAt'), body: row => isTableSkeletonRow(row)
                    ? tableCellSkeleton()
                    : formatDt(row.requestedAt ?? undefined) }), _jsx(Column, { header: translate('general.actions'), style: { width: '100px' }, body: actionBody })] }));
};
export const CardReplacementRequestTab = connect(mapState, mapDispatch)(CardReplacementRequestTabPresenter);
